import { render } from "./ConsentBulkCard.vue?vue&type=template&id=6042e124&scoped=true"
import script from "./ConsentBulkCard.vue?vue&type=script&lang=js"
export * from "./ConsentBulkCard.vue?vue&type=script&lang=js"

import "./ConsentBulkCard.vue?vue&type=style&index=0&id=6042e124&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6042e124"]])

export default __exports__